<!--
 * @Author: daidai
 * @Date: 2022-02-28 16:16:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-10-25 09:18:22
 * @FilePath: \web-pc\src\pages\big-screen\view\indexs\left-center.vue
-->
<template>
  <Echart id="leftCenter" :options="options" class="left_center_inner" v-if="pageflag" ref="charts" />
  <Reacquire v-else @onclick="getData" style="line-height:300px">
    重新获取
  </Reacquire>
</template>

<script>
import { currentGET } from 'api/modules'
import { statEquipmentTypeData } from 'api/modules/largescreen'
export default {
  data() {
    return {
      options: {},
      countUserNumData: {
        lockNum: 0,
        onlineNum: 0,
        offlineNum: 0,
        totalNum: 0
      },
      pageflag: true,
      timer: null
    };
  },
  created() {
    this.getData()
  },
  mounted() {
  },
  beforeDestroy() {
    this.clearData()

  },
  methods: {
    clearData() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    getData() {
      this.pageflag = true
      // this.pageflag =false
      // currentGET('big1').then(res => {
      //   //只打印一次
      //   if (!this.timer) {
      //     console.log("设备总览", res);
      //   }
      //   if (res.success) {
      //     this.countUserNumData = res.data
      //     this.$nextTick(() => {
      //       this.init()
      //     })

      //   } else {
      //     this.pageflag = false
      //     this.$Message({
      //       text: res.msg,
      //       type: 'warning'
      //     })
      //   }
      // })

      statEquipmentTypeData().then(res => {
          //只打印一次
          if (!this.timer) {
            console.log("设备类型", res);
          }
          if (res.code == 200) {
            this.countUserNumData = res.data
            this.$nextTick(() => {
              this.init()
            })

          } else {
            this.pageflag = false
            this.$Message({
              text: res.msg,
              type: 'warning'
            })
          }
        }
      )
    },
    //轮询
    switper() {
      if (this.timer) {
        return
      }
      let looper = (a) => {
        this.getData()
      };
      this.timer = setInterval(looper, this.$store.state.setting.echartsAutoTime);
      let myChart = this.$refs.charts.chart
      myChart.on('mouseover', params => {
        this.clearData()
      });
      myChart.on('mouseout', params => {
        this.timer = setInterval(looper, this.$store.state.setting.echartsAutoTime);
      });
    },
    init() {
      let total = this.countUserNumData.totalEquipmentCount;
      let echartsData = [];

      let dataList = this.countUserNumData.list;
      for (let i = 0; i < dataList.length; i++){
          let resData = dataList[i];
          echartsData.push({value: resData.col, name: resData.equipmentTypeName})
      }

      let colors = ["#ECA444", "#33A1DB", "#56B557"];
      let piedata = {
        name: "设备类型",
        type: "pie",
        radius: ["19%", "35%"],
        center: ['50%', '50%'], // 调整饼图中心点向上移动
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 4,
          borderColor: "rgba(0,0,0,0)",
          borderWidth: 2,
        },

        // color: colors,
        // data: [
        //   // {
        //   //   value: 0,
        //   //   name: "告警",
        //   //   label: {
        //   //     shadowColor: colors[0],
        //   //   },
        //   // },
        //   {
        //     value: this.countUserNumData.lockNum,
        //     name: "锁定",
        //     label: {
        //       shadowColor: colors[0],
        //     },
        //   },
        //   {
        //     value: this.countUserNumData.onlineNum,
        //     name: "在线",
        //     label: {
        //       shadowColor: colors[2],
        //     },
        //   },
        //   {
        //     value: this.countUserNumData.offlineNum,
        //     name: "离线",
        //     label: {
        //       shadowColor: colors[1],
        //     },
        //   },


        // ],
        data : echartsData,
      };
      this.options = {
        title: {
                text: ["{value|全县冷链设备数量" + total + "}", "{name|台}"].join(""),
                top: "1%",
                left: "center",
                textStyle: {
                    rich: {
                        value: {
                            color: "#ffffff",
                            fontSize: 24,
                            fontWeight: "bold",
                            lineHeight: 36,
                        },
                        name: {
                            color: "#ffffff",
                            lineHeight: 36,
                            fontSize: 24,
                        },
                    },
                },
            },
            tooltip: {
                trigger: "axis",
                backgroundColor: "rgba(0,0,0,.6)",
                borderColor: "rgba(147, 235, 248, .8)",
                textStyle: {
                    color: "#FFF",
                },
                formatter: function(params) {
                    return `${params[0].name}<br/>${params[0].marker}${params[0].value}台 (${(params[0].value/total*100).toFixed(1)}%)`;
                }
            },
            grid: {
                top: '15%',
                right: '5%',
                left: '10%',
                bottom: '15%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                data: echartsData.map(item => item.name),
                axisLine: {
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.5)'
                    }
                },
                axisLabel: {
                    color: '#fff',
                    fontSize: 14,
                    interval: 0,
                    rotate: 45
                }
            },
            yAxis: {
                type: 'value',
                name: '数量（台）',
                nameTextStyle: {
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontSize: 14
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.5)'
                    }
                },
                axisLabel: {
                    color: '#fff',
                    fontSize: 14
                },
                splitLine: {
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                }
            },
        series: [
          //展示圆点
          {
                    type: 'bar',
                    data: echartsData.map(item => {
                        return {
                            value: item.value,
                            name: item.name,
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [
                                        {offset: 0, color: '#43cbff'}, 
                                        {offset: 1, color: '#1a73e8'}
                                    ]
                                }
                            }
                        };
                    }),
                    barWidth: '40%',
                    label: {
                        show: true,
                        position: 'top',
                        formatter: '{c}台',
                        color: '#fff',
                        fontSize: 16,
                        fontWeight: 'bold'
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowColor: 'rgba(147, 235, 248, 0.8)'
                        }
                    }
                },
        ],
      };
    },
  },
};
</script>
<style lang='scss' scoped>
</style>